import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3123564e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "search-view"
};
import { nextTick, ref, computed } from 'vue';
import composition from '@/composition';
import debounce from 'lodash/debounce';
export default {
  props: {
    cid: Number,
    canEdit: Boolean
  },
  emits: ['selectTag'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const {
      request
    } = composition(); // 是否展示

    const show = ref(false); // 结果数组

    const results = ref([]); // 搜索内容

    const searchValue = ref('');
    const isShowCell = computed(() => {
      return name => {
        return name.indexOf(searchValue.value) != -1;
      };
    });

    function openSheet() {
      if (!props.canEdit) {
        return;
      }

      show.value = true;
      nextTick(() => {
        document.getElementById('searchView').scrollTop = 0;
      });
      request.getTimelineTags(props.cid, {}).then(res => {
        results.value = res.data;
      });
    } // 选择话题


    function selectTag(item) {
      if (!item) {
        // 不显示
        results.value = [];
        searchValue.value = '';
      }

      emits('selectTag', item);
      show.value = false;
    } // 输入


    const handleChange = debounce(value => {
      searchValue.value = value;
    }, 500);
    return (_ctx, _cache) => {
      const _component_van_search = _resolveComponent("van-search");

      const _component_van_cell = _resolveComponent("van-cell");

      const _component_van_action_sheet = _resolveComponent("van-action-sheet");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "open-btn",
        onClick: openSheet
      }, [_renderSlot(_ctx.$slots, "default")]), _createVNode(_component_van_action_sheet, {
        class: "search-sheet",
        id: "searchView",
        show: show.value,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => show.value = $event),
        title: "选择话题"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_search, {
          onInput: _cache[0] || (_cache[0] = $event => _unref(handleChange)($event.target.value)),
          placeholder: "输入想要添加的话题",
          shape: "round",
          clearable: false
        }), _createVNode(_component_van_cell, {
          title: "不使用",
          clickable: true,
          onClick: _cache[1] || (_cache[1] = $event => selectTag())
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, item => {
          return _withDirectives((_openBlock(), _createBlock(_component_van_cell, {
            key: item.id,
            title: '#' + item.name + '#',
            "title-class": "publish-tag-title",
            clickable: true,
            onClick: $event => selectTag(item)
          }, null, 8, ["title", "onClick"])), [[_vShow, _unref(isShowCell)(item.name)]]);
        }), 128))])]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }

};